// react
// dependencies
import { List, Map } from "immutable";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

// components
import Button from "../../../components/Button";

import Directory from "../../../containers/Directory";

// actions
import { openAddMembersCurtain } from "../actions";

// selectors
import { getAppHeight, getAppWidth } from "../../../selectors/app";
import { getEmployeesTableColumns, getGroupId } from "../selectors";

// Config
import Config from "../Config";

export class MembersScreen extends React.Component {
	/*
        The page for creating a review cycle.
    */

	static propTypes = {
		isActive: PropTypes.bool.isRequired,
		userIsAdmin: PropTypes.bool.isRequired,
		userIsAGroupAdmin: PropTypes.bool.isRequired,
		openAddMembersCurtain: PropTypes.func.isRequired,
		screenWidth: PropTypes.number.isRequired,
		screenHeight: PropTypes.number.isRequired,
		staticDirectoryFilters: PropTypes.instanceOf(Map).isRequired,
		columns: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	openCurtain = () => {
		this.props.openAddMembersCurtain();
	};

	render() {
		let { columns } = this.props;
		const { screenWidth, screenHeight, isActive, userIsAdmin, userIsAGroupAdmin, staticDirectoryFilters } =
			this.props;

		if (!isActive) {
			return <div />;
		}

		const verticalMargin = 0;
		const horizontalMargin = 0;
		const directoryWidth = screenWidth - horizontalMargin * 2;
		const directoryHeight = screenHeight - verticalMargin * 2;

		if (!userIsAdmin && !userIsAGroupAdmin) {
			columns = columns.filterNot((column) => column.get("_id") === "_remove");
		}

		// include 'Add Member' button
		const extraComponents =
			userIsAdmin || userIsAGroupAdmin
				? [
						<div
							className="add-more-employees-wrapper"
							key="add-members"
							style={{ position: "absolute", top: 0, right: 0 }}
						>
							<Button color="green" onClick={this.openCurtain}>
								Add Members
							</Button>
						</div>,
					]
				: [];

		return (
			<section className="employees-screen" style={{}}>
				<Directory
					showLetterPagination={false}
					width={directoryWidth}
					height={directoryHeight}
					filters={staticDirectoryFilters}
					storeName={Config.pageName}
					columns={columns}
					extraComponents={extraComponents}
					searchPlaceholder="search group members..."
				/>
			</section>
		);
	}
}

export const mapStateToProps = (state) => {
	const groupId = getGroupId(state);

	return {
		appWidth: getAppWidth(state),
		appHeight: getAppHeight(state),
		columns: getEmployeesTableColumns(state),
		staticDirectoryFilters: Map({
			groupID: groupId,
			membershipType: "member",
		}),
	};
};

const mapDispatchToProps = (dispatch) => ({
	openAddMembersCurtain: () => dispatch(openAddMembersCurtain()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MembersScreen);
